import Vue from 'vue';
import router from './router';
import store from './store/store';
import App from './App.vue';

import './style.scss';
import './plugins/element';
import './plugins/fontawesome';
import './plugins/v-charts';
import './plugins/infinite-loading';
import './plugins/google-maps';
import './plugins/axios';
import './directives/mask';
import 'leaflet/dist/leaflet.css'

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
